import * as React from 'react';
import { Container } from 'flux/utils';
import Link from 'components/Link';
import Badge from 'components/Badge';
import Image from 'components/Image';
import Text from 'components/Text';
// @ts-ignore
import UnreadStore from 'stores/UnreadStore';
import { AllClassesUnreadsKey } from 'constants/UnreadConstants';

import { NavigationList_me_navigationSections_items } from 'queries/__generated__/NavigationList';

import './styles/NavigationListGroupItem.scss';

type Props = {
  item: NavigationList_me_navigationSections_items;
};

type State = {
  unreadCount: number;
};

class NavigationListRootGroupItem extends React.Component<Props, State> {
  state = {
    unreadCount: 0,
  };

  static getStores() {
    return [UnreadStore];
  }

  static calculateState() {
    return {
      unreadCount: UnreadStore.getUnreadCount(AllClassesUnreadsKey),
    };
  }

  hasUnreads() {
    return this.state.unreadCount > 0;
  }

  renderBadge() {
    return (
      this.hasUnreads() && (
        <Badge
          className="NavigationListGroupItem-badge"
          count={this.state.unreadCount}
          color="lava"
          size="large"
          shape="square"
        />
      )
    );
  }

  render() {
    const { item } = this.props;

    return (
      <li className="NavigationListGroupItem">
        <Link
          color="inherit"
          to="/classes/r"
          activeClassName="active"
          className="NavigationListGroupItem-link">
          <div className="NavigationListGroupItem-container">
            <Image
              width={24}
              className="NavigationListGroupItem-avatar"
              src={require('assets/images/avatars/home.svg')}
            />
            <Text
              className="NavigationListGroupItem-name"
              weight={this.hasUnreads() ? 'semibold' : 'normal'}
              truncate>
              {item.displayName}
            </Text>
            {this.renderBadge()}
          </div>
        </Link>
      </li>
    );
  }
}

export default Container.create(NavigationListRootGroupItem, { withProps: true, pure: false });
